export const links = [
         {
           name: "Services",
           submenu: true,
           sublinks: [
             {
               Head: "Design & Development",
               sublink: [
                 { name: "Website Development", link: "/website-development" },
                 {
                   name: "Mobile App Development",
                   link: "/mobile-application-development",
                 },
                 {
                   name: "Software Development",
                   link: "/software-development",
                 },
                 {
                   name: "Web  Designing ",
                   link: "/web-design-development",
                 },

                 { name: "UI/UX Design ", link: "/uxuidesign" },
                 //  { name: "Digital Marketing ", link: "/digital-marketing" },
               ],
             },

             {
               Head: "Marketing",
               sublink: [
                 { name: "Digital Marketing ", link: "/digital-marketing" },
                 {
                   name: "Social Media Marketing",
                   link: "/social-media-marketing",
                 },
                 { name: "Content Marketing", link: "/content-marketing" },
                 {
                   name: "Search Engine Optimization",
                   link: "/search-engine-optimization",
                 },

                 { name: "Logo Design", link: "/logo-design" },
                 //  {
                 //    name: "Pay Per Click Marketing",
                 //    link: "/pay-per-click-marketing",
                 //  },
               ],
             },
             // {
             //   Head: "OTHERS",
             //   sublink: [
             //     { name: "Front End", link: "/" },
             //     { name: "Back End", link: "/" },
             //     { name: " Data", link: "/" },
             //   ],
             // },
           ],
         },
         // {
         //   name: "CASE STUDIES",
         //   submenu: true,
         //   sublinks: [
         //     {
         //       Head: "TOP",
         //       sublink: [
         //         { name: "Case Studies", link: "/CaseStudies" },
         //       ],
         //     },
         //     {
         //       Head: "TOP",
         //       sublink: [
         //         { name: "Case Studies", link: "/CaseStudies" },
         //       ],
         //     },
         //     {
         //       Head: "TOP",
         //       sublink: [
         //         { name: "Case Studies", link: "/CaseStudies" },
         //       ],
         //     },

         //   ],
         // },
         // {
         //   name: "CONTACT",
         //   submenu: true,
         //   sublinks: [
         //     {
         //       Head: "CONTACT US",
         //       sublink: [
         //         { name: "Contact US", link: "/contact" },
         //       ],
         //     },
         //     {
         //       Head: "ABOUT",
         //       sublink: [
         //         { name: "About Us", link: "/about" },

         //       ],
         //     },
         //     {
         //       Head: "TEAM",
         //       sublink: [
         //         { name: "Teams", link: "/teams" },
         //       ],
         //     },

         //   ],
         // },
       ];
